import React from "react";
import { LoginPasswordView } from "./LoginPasswordView";

export const SessionExpiredView: React.FC = () => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40 }}>
     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40 }}>
    <div style={{ color: 'red', fontWeight: 600, fontSize: 22, marginBottom: 24 }}>
      Session expired due to inactivity. Please sign in again.
    </div>
  </div>
    <div>
      <LoginPasswordView />
    </div>
  </div>
);
